import { render, staticRenderFns } from "./WhyITendtoPreferEquityRoundsOverNotesJP.vue?vue&type=template&id=6fdbbf71"
import script from "./WhyITendtoPreferEquityRoundsOverNotesJP.vue?vue&type=script&lang=js"
export * from "./WhyITendtoPreferEquityRoundsOverNotesJP.vue?vue&type=script&lang=js"
import style0 from "./WhyITendtoPreferEquityRoundsOverNotesJP.vue?vue&type=style&index=0&id=6fdbbf71&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports